import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { unitModeSelector } from '@store/metricLens/base/selectors';
import { updateUnit } from '@store/metricLens/base/actions';
import { track } from '@utils';
import { CLICK_ML_UNIT_MODE_CHANGE } from '@src/utils/sensor/track';
import UnitToggle from '@components/common/UnitToggle';

function UnitToggleWrapper() {
  const dispatch = useDispatch();
  const unit = useSelector(unitModeSelector);
  const [active, setActive] = useState('#');

  useEffect(() => {
    setActive(unit);
  }, [unit]);

  const handleSwitchChange = (value) => {
    setActive(value);
    dispatch(updateUnit(value));
    track({ event: CLICK_ML_UNIT_MODE_CHANGE, data: { unit: value } });
  };

  return <UnitToggle selectedUnit={active} onChange={handleSwitchChange} disabled={false} />;
}

export default UnitToggleWrapper;
